class VwPersonelDTO {
  id: number = 0;
  kimlikId?: number = null;
  ekleyenKullanici?: number = null;
  eklemeTarihi?: string = null;
  guncelleyenKullanici?: number = null;
  guncellemeTarihi?: string = null;
  durumId?: number = 1;
  grupId?: number = null;
  bransId?: number = null;
  organizasyonId?: number = 1;
  sicilNo?: string = "";
  ayrilistarih?: string = null;
  izinbaslangictarih?: string = null;
  izinbitistarih?: string = null;
  aileAdi?: string = "";
  treekey?: string = "";
  email?: string = "";
  adi?: string = "";
  soyadi?: string = "";
  kimlikNo?: string = "";
  searchText?: string = "";
  diplomaTescilNo?: string = "";
  drImza?: string = "";
  kontrolsuregun?: number = 0;

  //View Dışı Silinecekler
  kullaniciKodu?: string = "";
  durum?: string = "";
  grup?: string = "";
}
export default VwPersonelDTO;